import { useEffect, useState } from 'react';
import './App.css';
import nexusLogo from './assets/nexus-logo.png';
import avatarAvocat from './assets/avocat.jpeg';
import avatarProf from './assets/prof.jpeg';
import avatarMagistrat from './assets/magistrat.jpeg';
import sponsorCc from './assets/cc.jpeg';
import sponsorAfri from './assets/afri.jpeg';
import sponsorKny from './assets/kny.jpeg';
import sponsorY from './assets/y.jpeg';

const features = [
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z" />
        <circle cx="12" cy="10" r="3" />
      </svg>
    ),
    title: 'Cartographie Des Métiers 2026',
    text: 'Une lecture operationnelle des secteurs juridiques les plus porteurs au Cameroun pour orienter votre carriere.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
    title: 'Conseils De Recruteurs',
    text: "Maîtrisez les codes de l'entretien et les attentes des cabinets de premier rang pour faciliter votre insertion.",
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
        <polyline points="8 21 12 17 16 21" />
        <line x1="12" y1="17" x2="12" y2="21" />
      </svg>
    ),
    title: 'LegalTech & Innovation',
    text: 'Decouvrez comment les outils digitaux modernisent la pratique du droit et preparez la transition vers vos pratiques.',
  },
];

const sponsors = [
  {
    name: 'Cabinet CC Consulting',
    logo: sponsorCc,
  },
  {
    name: 'Africa First Finance',
    logo: sponsorAfri,
  },
  {
    name: 'KNY Group',
    logo: sponsorKny,
  },
  {
    name: 'Y-CONNEKT',
    logo: sponsorY,
  },
];

const speakers = [
  {
    name: 'Me. Macaire FOMEKONG',
    role: 'Avocat au Barreau du Cameroun et Consultant Juridique',
    text: 'Experte en droit public et en 20 ans de doctrine dans la pratique judiciaire.',
    avatar: avatarAvocat,
  },
  {
    name: 'Prof. TJOUEN Alex Francois',
    role: 'Professeur de Droit et Conseiller en Orientation Academique',
    text: 'Specialiste de l evolution des carrieres academiques en sciences juridiques.',
    avatar: avatarProf,
  },
  {
    name: 'Magister. Ulrich OVONO',
    role: 'Magistrat et Expert en Justice Numerique',
    text: 'Expert en legaltech et mentoring pratique. Habille votre CV de bonnes pratiques.',
    avatar: avatarMagistrat,
  },
];

const agenda = [
  // {
  //   time: '09:00',
  //   title: 'Accueil & Enregistrement',
  //   type: 'Accueil',
  //   text: 'Retrait de badge de bienvenue et cafe.',
  // },
  // {
  //   time: '10:00',
  //   title: 'Ceremonie d’ouverture',
  //   type: 'Institution',
  //   text: 'Discours inaugural sur le renouveau des metiers juridiques.',
  // },
  // {
  //   time: '11:00',
  //   title: 'Panel : Cartographie des Metiers 2026',
  //   type: 'Table ronde',
  //   text: 'Les segments qui recrutent encore en 2026 et les profils attendus.',
  // },
  // {
  //   time: '12:00',
  //   title: 'Pause Dejeuner & Networking',
  //   type: 'Rencontres',
  //   text: 'Mutualisation des opportunites et rencontres avec les cabinets.',
  // },
  // {
  //   time: '14:30',
  //   title: 'Atelier LegalTech',
  //   type: 'Atelier',
  //   text: 'Maîtriser les outils de production pour la justice moderne.',
  // },
  // {
  //   time: '16:30',
  //   title: 'Conseils de Recruteurs',
  //   type: 'Coaching',
  //   text: 'Session de mentorat express avec des DRH de grands groupes.',
  // },
];

const faqs = [
  {
    question: "Ou se deroule exactement l'événement ?",
    answer:
      'Le forum se tiendra à Yaounde Mvan au CNC Resource Center, salle principale. Un parking sécurisé est disponible.',
  },
  {
    question: 'Puis-je annuler mon inscription ?',
    answer:
      "Oui, jusqu'à 72h avant l'événement. Les demandes se font par email avec votre numéro de transaction.",
  },
  {
    question: 'Les certificats de participation sont-ils délivrés ?',
    answer:
      'Chaque participant récupère un certificat numérique vérifié à la fin de la journée.',
  }
];

const refundPolicyItems = [
  {
    title: 'Avant validation du paiement',
    text: 'Une inscription non finalisee ou sans preuve de paiement n est pas consideree comme validee et peut etre annulee sans frais.',
  },
  {
    title: 'Demande de remboursement',
    text: 'Toute demande doit etre transmise au plus tard 72 heures avant l evenement, avec le nom complet du participant et la reference de paiement.',
  },
  {
    title: 'Frais retenus',
    text: 'Les frais de transaction des operateurs de paiement peuvent etre deduits du montant rembourse selon le mode de paiement utilise.',
  },
  {
    title: 'Cas non remboursables',
    text: 'Aucun remboursement ne pourra etre accorde apres le delai de 72 heures, en cas d absence le jour J, ou si l acces a l evenement a deja ete confirme.',
  },
  {
    title: 'Delai de traitement',
    text: 'Les remboursements valides sont traites sous 5 a 10 jours ouvres via le meme canal de paiement lorsque cela est possible.',
  },
];

function App() {
  const [showHeader, setShowHeader] = useState(true);
  const [isRefundModalOpen, setIsRefundModalOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    let lastScrollY = window.scrollY;
    let ticking = false;

    const updateHeaderVisibility = () => {
      const currentScrollY = window.scrollY;
      const nearTop = currentScrollY <= 24;
      const scrollingUp = currentScrollY < lastScrollY - 4;
      const scrollingDown = currentScrollY > lastScrollY + 4;

      if (nearTop || scrollingUp) {
        setShowHeader(true);
      } else if (scrollingDown && currentScrollY > 120) {
        setShowHeader(false);
      }

      lastScrollY = currentScrollY;
      ticking = false;
    };

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateHeaderVisibility);
        ticking = true;
      }
    };

    updateHeaderVisibility();
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Ferme le menu mobile sur navigation ou resize
  useEffect(() => {
    const closeMenu = () => setIsMobileMenuOpen(false);
    if (isMobileMenuOpen) {
      window.addEventListener('resize', closeMenu);
    }
    return () => {
      window.removeEventListener('resize', closeMenu);
    };
  }, [isMobileMenuOpen]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        setIsRefundModalOpen(false);
      }
    };

    if (isRefundModalOpen) {
      document.body.style.overflow = 'hidden';
      window.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isRefundModalOpen]);

  return (
    <div className="page-shell">
      <div className="aurora aurora-a" />
      <div className="aurora aurora-b" />

      <header className={`site-header ${showHeader ? 'is-visible' : 'is-hidden'}`}>
        <div className="brand-wrap">
          <img className="brand-logo" src={nexusLogo} alt="Logo Nexus Africa" />
          <span className="brand-name">Nexus Africa</span>
        </div>
          <button
            className={`menu-toggle${isMobileMenuOpen ? ' is-active' : ''}`}
            aria-label="Ouvrir le menu"
            aria-expanded={isMobileMenuOpen}
            onClick={() => setIsMobileMenuOpen((v) => !v)}
          >
            <span className="menu-bar" />
            <span className="menu-bar" />
            <span className="menu-bar" />
          </button>

          <nav className={`main-nav${isMobileMenuOpen ? ' is-open' : ''}`} aria-label="Navigation principale">
            <a href="#apropos" onClick={() => setIsMobileMenuOpen(false)}>A propos</a>
            <a href="#panelistes" onClick={() => setIsMobileMenuOpen(false)}>Panelistes</a>
            <a href="#programme" onClick={() => setIsMobileMenuOpen(false)}>Programme</a>
            <a href="#faq" onClick={() => setIsMobileMenuOpen(false)}>FAQ</a>
            <div className="header-cta">
              <button type="button" className="ghost-btn">
                English
              </button>
              <a href="#inscription" className="solid-btn" onClick={() => setIsMobileMenuOpen(false)}>
                S inscrire
              </a>
            </div>
          </nav>
      </header>

      <main>
        <section id="apropos" className="hero-section card-panel reveal-up">
          <div className="hero-copy">
            <p className="pill">Edition 2026 | Yaounde</p>
            <h1>
              LE FORUM DE LA
              <span>CARRIERE</span>
              JURIDIQUE
            </h1>
            <p className="hero-text">
              Accelerer son insertion et anticiper les evolutions du Droit au
              Cameroun. Rejoignez les leaders du secteur pour batir votre futur.
            </p>

            <div className="hero-actions">
              <a href="#inscription" className="solid-btn">
                Reserver ma place
              </a>
              <button type="button" className="outline-btn">
                Soutenir le projet
              </button>
            </div>

            <p className="event-meta">15 Avril 2026 | Yaounde, CNC Resource Centre | Mvan</p>
          </div>

          <div className="hero-visual">
            <img
              src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=900&q=80"
              alt="Tour moderne"
            />
            <div className="overlay-card">
              <p>Nexus Africa</p>
              <strong>Vers le Droit 2.0</strong>
              <div className="avatars" aria-hidden="true">
                <img src={avatarAvocat} alt="Avocat" className="hero-avatar" />
                <img src={avatarProf} alt="Professeur" className="hero-avatar" />
                <img src={avatarMagistrat} alt="Magistrat" className="hero-avatar" />
              </div>
            </div>
          </div>
        </section>

        <section className="feature-grid reveal-up">
          {features.map((item) => (
            <article className="feature-card card-panel" key={item.title}>
              <span className="feature-icon">{item.icon}</span>
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </article>
          ))}
        </section>

        <section id="panelistes" className="reveal-up">
          <div className="section-heading">
            <h2>Panelistes d Exception</h2>
            <p>
              Des experts reconnus et des praticiens chevronnes reunis pour partager
              leur vision et leurs expertises.
            </p>
          </div>

          <div className="speaker-grid">
            {speakers.map((speaker) => (
              <article key={speaker.name} className="speaker-card card-panel">
                <img src={speaker.avatar} alt={speaker.name} />
                <h3>{speaker.name}</h3>
                <p className="speaker-role">{speaker.role}</p>
                <p>{speaker.text}</p>
                {/* <a href="#!" aria-label={`En savoir plus sur ${speaker.name}`}>
                  En savoir plus
                </a> */}
              </article>
            ))}
          </div>
        </section>

        <section id="inscription" className="register-wrap card-panel reveal-up">
          <div className="register-main">
            <h2>Inscription au Forum</h2>

            <div className="form-grid" aria-label="Formulaire d inscription">
              <div>
                <label>Prenom</label>
                <input defaultValue="Eric Jean" />
              </div>
              <div>
                <label>Nom</label>
                <input defaultValue="Eric Mbarga" />
              </div>
              <div className="full-col">
                <label>Email Professionnel</label>
                <input defaultValue="jean.mbarga@example.com"  />
              </div>
              <div>
                <label>Numero WhatsApp</label>
                <input defaultValue="+237 675 000 000"  />
              </div>
              <div>
                <label>Statut actuel</label>
                <select defaultValue="etudiant">
                  <option value="etudiant">Etudiant</option>
                  <option value="travailleur">Travailleur</option>
                </select>
              </div>
            </div>

            <div className="price-grid">
              <article>
                <h4>Etudiant</h4>
                <strong>3 000 FCFA</strong>
              </article>
              <article>
                <h4>Travailleur</h4>
                <strong>5 000 FCFA</strong>
              </article>
            </div>

            <button type="button" className="solid-btn full-btn">
              Confirmer mon inscription
            </button>
            <p className="register-disclaimer">
              En vous inscrivant, vous acceptez notre{' '}
              <button
                type="button"
                className="text-link-button"
                onClick={() => setIsRefundModalOpen(true)}
              >
                Politique de Remboursement
              </button>
            </p>
          </div>

          <aside className="payment-side">
            <h3>Modes de Paiement</h3>
            <div className="pay-card active">
              <span>OM</span>
              <div>
                <strong>Orange Money</strong>
                <p>Confirme en 10-30 min</p>
              </div>
            </div>
            <div className="pay-card">
              <span>MM</span>
              <div>
                <strong>MTN Mobile Money</strong>
                <p>Operation securisee</p>
              </div>
            </div>
            <div className="pay-card">
              <span>CB</span>
              <div>
                <strong>Carte Bancaire</strong>
                <p>Visa, Mastercard</p>
              </div>
            </div>

            <div className="donation-block">
              <h4>Soutenir l initiative</h4>
              <p>
                Nous aidons les jeunes talents a acceder a des outils de preparation
                concrets.
              </p>
              <button type="button" className="outline-btn pink">
                Faire un don au projet
              </button>
            </div>
          </aside>
        </section>

        <section id="programme" className="reveal-up">
          <div className="section-heading left">
            <h2>Programme de la Journee</h2>
            <p>
              Une journee dense articulee autour de sessions strategiques et
              d opportunites de networking.
            </p>
          </div>

          <div className="timeline">
            {agenda.length === 0 ? (
              <p className="agenda-empty">Programme pas encore disponible.</p>
            ) : (
              agenda.map((slot) => (
                <article className="timeline-item card-panel" key={slot.title}>
                  <span className="slot-time">{slot.time}</span>
                  <div>
                    <h3>{slot.title}</h3>
                    <small>{slot.type}</small>
                    <p>{slot.text}</p>
                  </div>
                </article>
              ))
            )}
          </div>
        </section>

        <section id="faq" className="faq card-panel reveal-up">
          <div className="section-heading">
            <h2>Questions Frequentes</h2>
            <p>Toutes les informations pratiques pour preparer votre venue.</p>
          </div>

          <div className="faq-list">
            {faqs.map((item, index) => (
              <details key={item.question} open={index === 0}>
                <summary>{item.question}</summary>
                <p>{item.answer}</p>
              </details>
            ))}
          </div>
        </section>

        <section className="partners reveal-up">
          <p>ILS NOUS FONT CONFIANCE</p>
          <div>
              {sponsors.map((sponsor) => (
                <article className="partner-card" key={sponsor.name}>
                  <img src={sponsor.logo} alt={sponsor.name} />
                  <span className="partner-name">{sponsor.name}</span>
                </article>
              ))}
          </div>
        </section>
      </main>

      <footer className="site-footer card-panel">
        <div>
          <h3>Nexus Africa Solutions</h3>
          <p>
            Première plateforme d'accélération de carrière pour les professionnels
            du droit et les jeunes diplômés.
          </p>
        </div>
        <div>
          <h4>Navigation</h4>
          <a href="#apropos">A propos</a>
          <a href="#programme">Programme</a>
          <a href="#faq">FAQ</a>
        </div>
        <div>
          <h4>Support & Legal</h4>
          <button
            type="button"
            className="footer-link-button"
            onClick={() => setIsRefundModalOpen(true)}
          >
            Politique de remboursement
          </button>
          <a href="#!">Contact</a>
        </div>
      </footer>

      {isRefundModalOpen ? (
        <div
          className="modal-overlay"
          onClick={() => setIsRefundModalOpen(false)}
          role="presentation"
        >
          <section
            className="policy-modal card-panel"
            role="dialog"
            aria-modal="true"
            aria-labelledby="refund-policy-title"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="policy-modal-header">
              <div>
                <p className="policy-modal-kicker">Support & Legal</p>
                <h2 id="refund-policy-title">Politique de remboursement</h2>
              </div>
              <button
                type="button"
                className="modal-close-btn"
                aria-label="Fermer la politique de remboursement"
                onClick={() => setIsRefundModalOpen(false)}
              >
                ×
              </button>
            </div>

            <p className="policy-modal-intro">
              Notre objectif est de garantir un traitement clair et equitable des demandes
              de remboursement liees a l inscription au Forum de la Carriere Juridique.
            </p>

            <div className="policy-modal-body">
              {refundPolicyItems.map((item) => (
                <article key={item.title} className="policy-point">
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </article>
              ))}
            </div>

            <div className="policy-modal-footer">
              <p>
                Pour toute demande, contactez l equipe organisatrice avec votre reference de
                paiement et vos informations d inscription.
              </p>
              <button
                type="button"
                className="solid-btn"
                onClick={() => setIsRefundModalOpen(false)}
              >
                J ai compris
              </button>
            </div>
          </section>
        </div>
      ) : null}
    </div>
  );
}

export default App;
